import { DefaultModalComponents } from '../ProjectModal/utils';
import styled from 'styled-components';
import AppCSS from '../../utils/styled';

export const Components = {
  ...DefaultModalComponents,
  Button: styled(AppCSS.buttonStyles.PrimaryButtonStyle)``,
  CancelButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,
};
